var _path;
import * as React from "react";
function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.157 9.23l-12-5a3.01 3.01 0 00-2.307 0l-12.001 5A2.997 2.997 0 004.999 12c0 12.407 7.157 20.983 13.845 23.77a3.01 3.01 0 002.306 0c5.357-2.23 13.852-9.938 13.852-23.77a3.001 3.001 0 00-1.845-2.77zm-2.95 7.138l-11.5 11.502a1.003 1.003 0 01-1.413 0l-6.501-6.501a1.004 1.004 0 010-1.413l1.413-1.412a1.004 1.004 0 011.412 0L18 22.925l9.382-9.382a1.004 1.004 0 011.413 0l1.412 1.413a.992.992 0 010 1.412z"
  })));
}
export default SvgShield;